import { DATE_RANGE_PRESETS, resolveDateRange } from "../../lib/dateRangeFilter";

/**
 * Preset + custom date range picker for analytics cohorts.
 * @param {{ value: { preset: string, customStart?: string, customEnd?: string }, onChange: Function, compact?: boolean, className?: string }} props
 */
export default function DateRangeFilter({ value, onChange, compact = false, className = "" }) {
  const preset = value?.preset || "all";
  const resolved = resolveDateRange(value);
  const showCustom = preset === "custom";

  const setPreset = (id) => {
    onChange?.({
      preset: id,
      customStart: value?.customStart || "",
      customEnd: value?.customEnd || "",
    });
  };

  const setCustomField = (field, next) => {
    onChange?.({
      preset: "custom",
      customStart: field === "customStart" ? next : value?.customStart || "",
      customEnd: field === "customEnd" ? next : value?.customEnd || "",
    });
  };

  return (
    <div className={`date-range-filter ${compact ? "date-range-filter--compact" : ""} ${className}`}>
      <div className="date-range-filter-presets">
        {DATE_RANGE_PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            className={`filter-chip ${preset === p.id ? "active" : ""}`}
            onClick={() => setPreset(p.id)}
          >
            {p.label}
          </button>
        ))}
      </div>
      {showCustom ? (
        <div className="date-range-filter-custom">
          <label className="date-range-filter-date">
            <span>From</span>
            <input
              type="date"
              className="input"
              value={value?.customStart || ""}
              onChange={(e) => setCustomField("customStart", e.target.value)}
            />
          </label>
          <label className="date-range-filter-date">
            <span>To</span>
            <input
              type="date"
              className="input"
              value={value?.customEnd || ""}
              onChange={(e) => setCustomField("customEnd", e.target.value)}
            />
          </label>
        </div>
      ) : null}
      {!compact && !resolved.isAllTime && !resolved.invalid ? (
        <div className="date-range-filter-label text-caption">{resolved.label}</div>
      ) : null}
    </div>
  );
}
